import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {
  AsyncPipe,
  CurrencyPipe,
  DatePipe,
  DecimalPipe,
  I18nPluralPipe,
  I18nSelectPipe,
  JsonPipe,
  KeyValuePipe,
  LowerCasePipe,
  PercentPipe,
  SlicePipe,
  TitleCasePipe as AngularTitleCasePipe,
  UpperCasePipe
} from '@angular/common';

export function provideAngularPipes(): EnvironmentProviders {
  return makeEnvironmentProviders([
    AngularTitleCasePipe,
    AsyncPipe,
    CurrencyPipe,
    DatePipe,
    DecimalPipe,
    I18nPluralPipe,
    I18nSelectPipe,
    JsonPipe,
    KeyValuePipe,
    LowerCasePipe,
    PercentPipe,
    SlicePipe,
    UpperCasePipe
  ]);
}
